import shuffleArray from '@uikit/helpers/shuffleArray';
import { useCallback, useMemo, useState } from 'react';
import { EnergyGuzzlerWithFinishedItem } from '../../EnergyGuzzlersPageContent/types';
import getEnergyGuzzlersFlatList from '../helpers/getEnergyGuzzlersFlatList';

const createInitialState = (): EnergyGuzzlerWithFinishedItem[] => [
  ...shuffleArray(getEnergyGuzzlersFlatList()),
  { type: 'finish' },
];

export default function useQuiz() {
  const [currentEnergyGuzzlerIndex, setCurrentEnergyGuzzlerIndex] = useState(0);
  const [energyGuzzlers, setEnergyGuzzlers] = useState(() =>
    createInitialState()
  );
  const [savingsAmount, setSavingsAmount] = useState(0);

  const isLastIndex = useMemo(
    () => currentEnergyGuzzlerIndex === energyGuzzlers.length - 1,
    [energyGuzzlers, currentEnergyGuzzlerIndex]
  );

  const gotoNextEnergyGuzzler = useCallback(() => {
    setCurrentEnergyGuzzlerIndex((prevIndex) => {
      if (!isLastIndex) {
        return prevIndex + 1;
      }

      return prevIndex;
    });

    const currentGuzzler = energyGuzzlers[currentEnergyGuzzlerIndex];

    if (currentGuzzler.type === 'question') {
      setSavingsAmount(
        (prevSavingsAmount) => prevSavingsAmount + currentGuzzler.savingsAmount
      );
    }
  }, [currentEnergyGuzzlerIndex, energyGuzzlers, isLastIndex]);

  const isValidAnswer = (answer: string) => {
    const currentGuzzler = energyGuzzlers[currentEnergyGuzzlerIndex];

    if (currentGuzzler.type === 'question') {
      return answer === currentGuzzler.correctAnswer;
    }
  };

  const restartQuiz = () => {
    setSavingsAmount(0);
    setEnergyGuzzlers(() => createInitialState());
    setCurrentEnergyGuzzlerIndex(0);
  };

  const cheatQuiz = () => {
    setCurrentEnergyGuzzlerIndex(energyGuzzlers.length - 1);
    setSavingsAmount(3334);
  };

  return {
    currentEnergyGuzzlerIndex,
    energyGuzzlers,
    gotoNextEnergyGuzzler,
    isFinished: isLastIndex,
    isValidAnswer,
    restartQuiz,
    savingsAmount,
    cheatQuiz,
  };
}
